import http from "@/api/api"

    //获取APP版本最后一条信息
export const getAppVersion = async () => {
    let res = await http.get("/tenant/version/getNew");
    return res.data;
}


//通过ID查询租户信息
export const getTenantById = async (id) => {
    let res = await http.get(`/tenant/safeTenant/${id}`);
    return res;
}



